interface MarkerListItem {
  marker?: google.maps.Marker
}

interface AdvanceMarkerListItem {
  marker?: google.maps.marker.AdvancedMarkerElement
}

export default () => {
  let map: null | google.maps.Map = null
  let placesService: google.maps.places.PlacesService
  const markers = ref<MarkerListItem[]>([])
  const advancedMarkers = ref<AdvanceMarkerListItem[]>([])
  const advancedMarkerList = reactive<any>({})

  const MarkerLoader = (mapInstance: null | google.maps.Map) => {
    map = mapInstance
    if (map) {
      placesService = new google.maps.places.PlacesService(map)
    }
  }
  /** show marker when click on map (not place) */
  const clickPositionMarker: any = ref(null)
  const createMarker = (position: any, title?: string, extra?: null | { [key: string]: any }): null | google.maps.Marker => {
    if (!map) {
      return null
    }
    const marker = new google.maps.Marker({
      position,
      map,
      title,
      draggable: false
    })
    markers.value.push({ marker, ...extra })
    return marker
  }

  const createAdvanceMarker = async (
    positionOrPlaceId?: google.maps.LatLng | google.maps.LatLngLiteral | string | null,
    htmlContent?: null | Node,
    extra?: null | { [key: string]: any },
    options?: any
  ): Promise<google.maps.marker.AdvancedMarkerElement | null> => {
    if (!map) {
      return null
    }

    if (typeof positionOrPlaceId === 'string') {
      return await new Promise((resolve, reject) => {
        placesService.getDetails(
          {
            placeId: positionOrPlaceId
          },
          (place: google.maps.places.PlaceResult | null, status: google.maps.places.PlacesServiceStatus) => {
            if (status === google.maps.places.PlacesServiceStatus.OK && place) {
              resolve(
                new google.maps.marker.AdvancedMarkerElement({
                  map,
                  position: place.geometry?.location,
                  content: htmlContent
                })
              )
            } else {
              reject(status)
            }
          }
        )
      })
    }

    const marker = new google.maps.marker.AdvancedMarkerElement({
      ...{
        map,
        position: positionOrPlaceId,
        content: htmlContent
      },
      ...(options?.styles || {})
    })
    if (typeof options?.list === 'string') {
      if (Array.isArray(advancedMarkerList[options?.list])) {
        advancedMarkerList[options?.list].push({
          marker,
          ...extra
        })
      } else {
        advancedMarkerList[options?.list] = [
          {
            marker,
            ...extra
          }
        ]
      }
    } else {
      advancedMarkers.value.push({
        marker,
        ...extra
      })
    }
    return marker
  }

  const createAdvanceMarkers = (
    positions: (google.maps.LatLng | google.maps.LatLngLiteral)[],
    htmlContent?: null | Node,
    extra?: null | { [key: string]: any }
  ) => {
    if (!map) {
      return
    }

    positions.forEach((position) => {
      createAdvanceMarker(position, htmlContent, extra)
    })
  }

  const removeAllMarkers = () => {
    removeMarkers()
    removeAdvanceMarkers()
  }

  const removeAllMarkerList = (list: string) => {
    if (list && Array.isArray(advancedMarkerList[list]) && advancedMarkerList[list].length) {
      advancedMarkerList[list].forEach(({ marker }) => {
        if (marker) {
          marker.map = null
        }
      })

      advancedMarkerList[list] = []
    }
  }

  const removeMarkers = () => {
    markers.value.forEach(({ marker }) => {
      // marker?.setMap(null)
      marker?.setVisible(false)
    })
    markers.value = []
  }

  const removeAdvanceMarkers = () => {
    advancedMarkers.value.forEach(({ marker }) => {
      if (marker) {
        marker.map = null
      }
    })

    advancedMarkers.value = []
  }

  const removeAdvanceMarker = (fn: Function) => {
    const indexAdvanceMarker = advancedMarkers.value.findIndex((item: { [key: string]: any }) => {
      return fn(item)
    })
    if (indexAdvanceMarker >= 0 && advancedMarkers.value && advancedMarkers.value[indexAdvanceMarker].marker?.map) {
      const marker = advancedMarkers.value[indexAdvanceMarker].marker
      if (marker) {
        marker.map = null
        advancedMarkers.value.splice(indexAdvanceMarker, 1)
      }
    }
  }

  const setVisibleAllMarkers = (visible: boolean) => {
    markers.value.forEach(({ marker }) => {
      marker?.setVisible(visible)
    })
    advancedMarkers.value.forEach(({ marker }) => {
      if (visible) {
        marker?.content?.parentElement?.firstElementChild?.classList.remove('!hidden')
      } else {
        marker?.content?.parentElement?.firstElementChild?.classList.add('!hidden')
      }
    })
  }

  const setAllMarkerSize = (zoom: number) => {
    advancedMarkers.value.forEach(({ marker }) => {
      marker?.content?.parentElement?.firstElementChild?.setAttribute('size', parseInt(zoom.toString()).toString())
    })
  }

  const modifyAdvanceMarker = (marker?: google.maps.marker.AdvancedMarkerElement, htmlContent?: Node, extra?: null | { [key: string]: any }) => {
    if (!htmlContent || !marker) {
      return
    }
    marker.map = null
    const advanceMarker = advancedMarkers.value.findIndex((i) => i.marker === marker)
    if (advanceMarker >= 0) {
      advancedMarkers.value.splice(advanceMarker, 1)
    }
    return createAdvanceMarker(marker.position, htmlContent, extra)
  }

  const hideClickPositionMarker = () => {
    clickPositionMarker.value && clickPositionMarker.value.setVisible(false)
  }

  const showClickPositionMarker = () => {
    clickPositionMarker.value && clickPositionMarker.value.setVisible(true)
  }

  return {
    MarkerLoader,
    markers,
    advancedMarkers,
    clickPositionMarker,
    createMarker,
    createAdvanceMarker,
    createAdvanceMarkers,
    removeMarkers,
    removeAdvanceMarkers,
    removeAllMarkers,
    removeAllMarkerList,
    setVisibleAllMarkers,
    setAllMarkerSize,
    modifyAdvanceMarker,
    hideClickPositionMarker,
    showClickPositionMarker,
    removeAdvanceMarker
  }
}
